export default {
  deselectKey: 'Right-click to deselect',
  bindWechatSuccess: 'WeChat bound successfully',
  wechatLoginFail: 'Failed to connect to WeChat login service',
  changePasswordSuccess: 'Password changed successfully',
  loading: 'Please wait, another operation is in progress.',
  light: {
    maxLimit: 'Reached maximum custom mode count, cannot add more',
    noSelect: 'Please press any key on the keyboard',
  },
  device: {
    initializeFailed: 'Device service initialization failed',
    scanFailed: 'Device scan failed',
    disconnected: 'The device is disconnected',
    disconnected2: 'No device detected. Please check if it has been disconnected and reconnect it.',
    connectedFailed: 'Unable to connect to the device',
    connectedFailed2:
      'Unable to connect to the device. Please check if the device is in sleep mode or verify that it has been properly added, then try again.',
    fail: 'Failed to retrieve data. Please check your device or try again later.',
  },
  keys: {
    disableBeforeSwitch:
      'Please turn off the {type} function before changing this key to another function key',
    maxFnMappings: 'A maximum of 4 keys can be remapped to Fn',
    advancedSlotFull: 'Advanced remap slots are full. Restore another key first, then try again.',
    advancedTypeFull:
      'You have reached the maximum number of {type} bindings. Delete an existing one first.',
    advancedDeleted: 'Advanced key binding deleted',
    mtApply: 'Click "Apply" to finish assigning the MT function',
    mtSelect:
      'Select any key on the virtual keyboard first before applying the MT remap for this key',
    advancedSelectKey: 'Select a key on the virtual keyboard above first before binding',
    comingSoon: 'This feature is still in development',
    dksApply: 'Click "Apply" to finish assigning the DKS function',
    dksSelectKeyFirst: 'Select a key first',
    dksSelect:
      'Select any key on the virtual keyboard first before applying the DKS remap for this key',
    tglApply: 'Click "Apply" to finish assigning the TGL function',
    tglSelect:
      'Select any key on the virtual keyboard first before applying the TGL remap for this key',
    rsApply: 'Click "Apply" to finish assigning the RS function',
    rsSelect: 'Select two keys on the virtual keyboard first before applying the RS remap',
    rsSameKey: 'RS requires two different keys',
    socdApply: 'Click "Apply" to finish assigning the SOCD function',
    socdSelect: 'Select two keys on the virtual keyboard first before applying the SOCD remap',
    socdSameKey: 'SOCD requires two different keys',
    fnNotSupported: 'The Fn key cannot be modified',
    keyNotSupported: 'The key cannot be modified',
    factoryLocked: 'Factory preset function keys cannot be modified',
    macroMax128: 'Up to 128 macros are supported',
    macroMax: 'Up to {count} macros are supported',
    macroSaved: 'Macro saved',
    macroBindSelectKey: 'Choose any key on the virtual keyboard to bind this macro',
    macroBindSelectMacro: 'Choose any macro file to bind and assign to the selected key',
    macroJsonOnly: 'Only .json files are supported',
    macroMissingTopLevel: 'Invalid file format: missing Macro or Platform field',
    macroMissingFields: 'Invalid file format: Macro is missing fields {fields}',
    macroDuplicateId: 'Import failed: ID {id} already exists',
    macroImportSuccess: 'Macro file imported successfully',
    macroParseFailed: 'Failed to parse the file. Check the file contents.',
    macroMax12: 'Up to 12 macros are supported',
    macroRenameEmpty: 'Name cannot be empty',
    macroRenameTruncated: 'The name is limited to 16 bytes and has been truncated automatically',
    macroEmptyUnsupported: 'Blank macros cannot be assigned',
    macroRecordingLimit: 'The macro action count has reached the limit',
    macroRecordingLimit2: 'The macro content exceeds the maximum length',
    tLeastOne: 'Please select at least one key',
    atLeastOneLeftClick: 'At least one left click must be retained',
    wheelOnly: 'Only the mouse wheel supports wheel-related key mapping changes',
    wheelRestricted:
      'The mouse wheel does not support Fire button, Sniper button, DPI-related, configuration switching, or dongle switching functions',
    wheelRestricted2: 'The roller buttons do not support the function of setting macros.',
    exportSuccess: 'Macro export successful.',
  },
  firmware: {
    upgrading: 'Firmware upgrade in progress. Please do not repeat the operation.',
    upgradeFailed: 'Firmware upgrade failed. Please try again.',
    downloadFailed: 'Failed to download the firmware package.',
    hexNotFound: 'No .hex firmware file found in the archive.',
    upgradeListFailed: 'Failed to query update logs',
  },
  factoryReset: {
    success: 'Factory reset successful.',
  },
  cloud: {
    uploadFail: 'Upload failed',
    uploadSuccess: 'Upload successful',
    loginExpiredUpload: 'Your session has expired. Please log in and upload again.',
    downloadFail: 'Download failed',
    downloadSuccess: 'Download successful',
    operating: 'Operation in progress, please wait',
    selectConfig: 'Please select a configuration file',
    deleteFail: 'Delete failed',
    deleteSuccess: 'Deleted successfully',
  },
  configuration: {
    getListFail: 'Failed to get configuration list',
    getCurrentFail: 'Failed to get current configuration',
    notSupported: 'Current device does not support configuration',
    createSuccess: 'Configuration created successfully: {name}',
    createFail: 'Failed to create configuration',
    maxLimitReached: 'The maximum number of custom configurations has been reached',
    maxLimitName: 'The configuration name is too long',
    defaultDeleteForbidden: 'Default configuration cannot be deleted',
    currentInUseDeleteForbidden: 'Cannot delete the currently active configuration',
    deleteSuccess: 'Configuration deleted successfully',
    deleteFail: 'Failed to delete configuration',
    defaultRenameForbidden: 'Default configuration cannot be renamed',
    renameSuccess: 'Renamed successfully',
    renameFail: 'Failed to rename',
    switchSuccess: 'Configuration switched successfully',
    switchFail: 'Failed to switch configuration',
  },
}
